/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-07-02 10:01:19
 * @LastEditors: hongye
 * @LastEditTime: 2025-08-06 13:53:42
 */
import { defineStore } from 'pinia'
import { orderService } from '@/service/api'
interface ExpressListVo {
  label: string
  value: string
}
export const useExpressList = defineStore('express', {
  state: () => ({
    express: '',
    /**快递公司 */
    expressList: [] as ExpressListVo[]
  }),
  getters: {
    getExpressData: (state) => state.expressList
  },
  actions: {
    /**
     * 获取所有快递公司
     * @param
     * @returns promise
     */
    getExpressList() {
      return new Promise((resolve, reject) => {
        orderService.getExpressCompany()
          .then((res) => {
            if (res.code === 1) {
              this.expressList = []
              res.data.forEach((_: Record<string, any>) => {
                this.expressList.push({
                  label: _.name,
                  value: _.id
                })
                if(_.id === 'JT_EXPRESS'){
                  this.express = _.id
                }
              })
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
